import React from 'react';
import { Link } from 'react-router-dom';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import GoldText from '../components/GoldText';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <SiteNav />
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-display text-6xl font-bold mb-4"><GoldText>404</GoldText></h1>
        <p className="text-textSecondary mb-8">This page doesn't exist.</p>
        <Link to="/" className="px-6 py-3 bg-gold-gradient text-bg rounded-lg font-semibold hover:opacity-90 transition">
          Back to Home
        </Link>
      </div>
      <SiteFooter />
    </div>
  );
}
